import { IDataRow } from 'react-bootstrap-table-next';
import { IVendorOrderData } from '../../types/vendorDashboard/IVendorOrders';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';
import { BodyText, NavigationItem, TextTag } from '../../ui-toolkit';
import React from 'react';
import { prettyVendorStatus, vendorStatusTagColor } from '../../types/order/title/eTitleSearchStatus';
import { getDaysAgoString } from '../../ui-toolkit/utilities/getDaysAgoString';

const fileNumberFormatter = (
  _cell: IDataRow<IVendorOrderData>[keyof IDataRow<IVendorOrderData>],
  row?: IDataRow<IVendorOrderData>
) => {
  if (!row) return null;
  return (
    <NavigationItem
      intent={'primary'}
      appearance={'minimal'}
      text={row.fileNumber}
      to={ClientUrlFactory().urlFor.vendorOrder(row.orderId)}
    />
  );
};

const addressFormatter = (
  _cell: IDataRow<IVendorOrderData>[keyof IDataRow<IVendorOrderData>],
  row?: IDataRow<IVendorOrderData>
) => {
  if (!row) return null;
  return <BodyText>{`${row.address.city}, ${row.address.stateAbbreviation}`}</BodyText>;
};

const timeEnteredQueueFormatter = (
  _cell: IDataRow<IVendorOrderData>[keyof IDataRow<IVendorOrderData>],
  row?: IDataRow<IVendorOrderData>
) => {
  if (!row) return null;
  return <BodyText>{getDaysAgoString(row.timeEnteredQueue)}</BodyText>;
};

const statusFormatter = (
  _cell: IDataRow<IVendorOrderData>[keyof IDataRow<IVendorOrderData>],
  row?: IDataRow<IVendorOrderData>
) => {
  if (!row) return null;
  return <TextTag type={vendorStatusTagColor[row.status]} text={prettyVendorStatus[row.status]} />;
};

export const OrdersTableFormatters = {
  fileNumberFormatter,
  addressFormatter,
  timeEnteredQueueFormatter,
  statusFormatter,
};
